import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../css/Decants.css";
import axiosInstance from "../config";
import logo1 from '../logo/logo1.png';
import { toast } from "react-toastify";
export default function Decants() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cart, setCart] = useState([]);
  const [showCart, setShowCart] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [hoveredSize, setHoveredSize] = useState(null);
  const [sizeImage, setSizeImage] = useState("");
  const [sizeDescription, setSizeDescription] = useState("");
  const [allSizes, setAllSizes] = useState([]);
  const [groupedProducts, setGroupedProducts] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [selectedShipping, setSelectedShipping] = useState("standard");
  const [sizeInfoMap, setSizeInfoMap] = useState({});

  const [logoData, setLogoData] = useState(null);
  const [logoLoading, setLogoLoading] = useState(true);
  const MIN_CHECKOUT_AMOUNT = 1000;
  const STANDARD_SHIPPING_RATE = 100;
  const EXPRESS_SHIPPING_RATE = 150;
  const STANDARD_FREE_THRESHOLD = 3000;
  const EXPRESS_FREE_THRESHOLD = 5000;
  const navigate = useNavigate();
  useEffect(() => {
    fetchProducts();
    fetchLogoData();
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const getFullImageUrl = (imagePath) => {
    if (!imagePath) return "";
    if (imagePath.startsWith('http')) {
      return imagePath;
    }
    const baseUrl = 'http://192.168.1.5/decants/public';
    return `${baseUrl}/storage/size_images/${imagePath}`;
  };

  // Fetch logo data function
  const fetchLogoData = async () => {
    try {
      setLogoLoading(true);
      console.log('Fetching logo data for Decants...');

      const logoResponse = await axiosInstance.get('/user/logos');
      console.log('Logo API Response:', logoResponse.data);

      if (logoResponse.data.success && logoResponse.data.data && logoResponse.data.data.length > 0) {
        // Get the first active logo
        const activeLogo = logoResponse.data.data.find(logo => logo.is_active === true);
        console.log('Active Logo Found:', activeLogo);
        
        if (activeLogo) {
          setLogoData(activeLogo);
          console.log('Logo URL to load:', activeLogo.image_url);
        } else {
          console.log('No active logo found');
        }
      } else {
        console.log('No logo data received or API not successful');
      }

    } catch (err) {
      console.error('Error fetching logo data:', err);
    } finally {
      setLogoLoading(false);
      console.log('Logo loading complete');
    }
  };

  const handleLogoError = (e) => {
    console.error('Logo image failed to load:', e.target.src);
    e.target.style.display = 'none';
  };

  const calculateShipping = (subtotal) => {
    if (selectedShipping === "express") {
      if (subtotal >= EXPRESS_FREE_THRESHOLD) {
        return 0;
      } else if (subtotal >= STANDARD_FREE_THRESHOLD) {
        return 50;
      } else {
        return EXPRESS_SHIPPING_RATE;
      }
    } else {
      if (subtotal >= STANDARD_FREE_THRESHOLD) {
        return 0;
      } else {
        return STANDARD_SHIPPING_RATE;
      }
    }
  };

  const calculateExpressUpgradeCost = (subtotal) => {
    if (subtotal >= EXPRESS_FREE_THRESHOLD) {
      return 0;
    } else if (subtotal >= STANDARD_FREE_THRESHOLD) {
      return 50;
    } else {
      return EXPRESS_SHIPPING_RATE - STANDARD_SHIPPING_RATE;
    }
  };

  // const generateFragranticaUrl = (brand, productName) => {
  //   if (!brand || !productName) return "";
    
  //   const cleanBrand = brand
  //     .toLowerCase()
  //     .replace(/[^\w\s-]/g, '') 
  //     .replace(/\s+/g, '-')     
  //     .replace(/--+/g, '-')     
  //     .trim();
    
  //   const cleanProductName = productName
  //     .toLowerCase()
  //     .replace(/[^\w\s-]/g, '')
  //     .replace(/\s+/g, '-')      
  //     .replace(/--+/g, '-') 
  //     .trim();

  //   return `https://www.fragrantica.com/perfume/${cleanBrand}/${cleanProductName}-37473.html`;
  // };



  const generateFragranticaSearchUrl = (brand, productName) => {
    if (!brand || !productName) return "";
  
    const query = encodeURIComponent(
      `${brand} ${productName} site:fragrantica.com`
    );
  
    return `https://www.google.com/search?q=${query}`;
  };
  
  // const getProductLink = (product) => {
  //   if (product.link && product.link.trim() !== '') {
  //     return product.link;
  //   }
    
  //   return generateFragranticaUrl(product.brand, product.product_name);
  // };


  const getProductLink = (product) => {
    if (product.link && product.link.trim() !== '') {
      return product.link;
    }
  
    return generateFragranticaSearchUrl(
      product.brand,
      product.product_name
    );
  };
  
  const fetchProducts = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/user/products");
      
      if (response.data.success && response.data.data) {
        const activeProducts = response.data.data.filter(product => product.is_active);
        
        const productsWithLinks = activeProducts.map(product => ({
          ...product,
          generatedLink: getProductLink(product)
        }));
        
        setProducts(productsWithLinks);
        
        const allSizesSet = new Set();
        const sizeInfoMap = {};
        
        productsWithLinks.forEach(product => {
          if (product.sizes && Array.isArray(product.sizes)) {
            product.sizes.forEach(size => {
              if (size.size) {
                allSizesSet.add(size.size);
                if (!sizeInfoMap[size.size]) {
                  sizeInfoMap[size.size] = {
                    image: size.image || "",
                    description: size.description || ""
                  };
                } else {
                  if (!sizeInfoMap[size.size].image && size.image) {
                    sizeInfoMap[size.size].image = size.image;
                  }
                  if (!sizeInfoMap[size.size].description && size.description) {
                    sizeInfoMap[size.size].description = size.description;
                  }
                }
              }
            });
          }
          
          if (product.available_sizes && Array.isArray(product.available_sizes)) {
            product.available_sizes.forEach(size => {
              if (size.size && !sizeInfoMap[size.size]) {
                sizeInfoMap[size.size] = {
                  image: getFullImageUrl(size.image),
                  description: size.description || ""
                };
              }
            });
          }
        });
        
        const allSizesArray = Array.from(allSizesSet).sort((a, b) => {
          const getNumericValue = (sizeStr) => {
            const match = sizeStr.match(/(\d+(\.\d+)?)/);
            return match ? parseFloat(match[1]) : 0;
          };
          return getNumericValue(a) - getNumericValue(b);
        });
        
        setAllSizes(allSizesArray);
        setSizeInfoMap(sizeInfoMap);
        
        const grouped = groupProductsByBrandAndName(productsWithLinks, allSizesArray);
        setGroupedProducts(grouped);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };

  const groupProductsByBrandAndName = (products, sizesList) => {
    const groupedMap = {};
    
    products.forEach(product => {
      const key = `${product.brand}|${product.product_name}`;
      
      if (!groupedMap[key]) {
        groupedMap[key] = {
          id: product.id,
          brand: product.brand,
          product_name: product.product_name,
          link: product.link,
          generatedLink: product.generatedLink,
          is_new: product.is_new,
          is_active: product.is_active,
          variants: [],
          sizePrices: {}
        };
      }
      
      // Initialize all sizes with empty prices
      sizesList.forEach(size => {
        groupedMap[key].sizePrices[size] = '';
      });
      
      // Fill in available sizes - use available_sizes for prices
      if (product.available_sizes && product.available_sizes.length > 0) {
        product.available_sizes.forEach(availableSize => {
          if (availableSize.size) {
            groupedMap[key].sizePrices[availableSize.size] = availableSize.price;
            
            const existingVariant = groupedMap[key].variants.find(
              v => v.size === availableSize.size
            );
            
            if (!existingVariant) {
              groupedMap[key].variants.push({
                id: product.id,
                size_ml: parseFloat(availableSize.size),
                price: availableSize.price,
                size: availableSize.size,
                size_key: availableSize.size_key
              });
            }
          }
        });
      }
    });
    
    const groupedArray = Object.values(groupedMap).sort((a, b) => {
      // Sort by new status first
      if (a.is_new && !b.is_new) return -1;
      if (!a.is_new && b.is_new) return 1;

      // Then sort by brand
      const brandA = a.brand.toLowerCase();
      const brandB = b.brand.toLowerCase();
      
      if (brandA < brandB) return -1;
      if (brandA > brandB) return 1;
      
      // Then sort by product name
      const productA = a.product_name.toLowerCase();
      const productB = b.product_name.toLowerCase();
      
      if (productA < productB) return -1;
      if (productA > productB) return 1;
      return 0;
    });
    
    return groupedArray;
  };

  // const filterData = (data, searchValue) => {
  //   if (!searchValue.trim()) {
  //     return data;
  //   }

  //   const searchLower = searchValue.toLowerCase().trim();
    
  //   return data.filter(group => {
  //     const brand = group.brand?.toLowerCase() || '';
  //     const productName = group.product_name?.toLowerCase() || '';
      
  //     const brandWords = brand.split(/\s+/);
  //     const brandMatch = brandWords.some(word => 
  //       word.startsWith(searchLower)
  //     );
      
  //     const productWords = productName.split(/\s+/);
  //     const productMatch = productWords.some(word => 
  //       word.startsWith(searchLower)
  //     );
      
  //     return brandMatch || productMatch;
  //   }).sort((a, b) => {
  //     const brandA = a.brand?.toLowerCase() || '';
  //     const brandB = b.brand?.toLowerCase() || '';
  //     return brandA.localeCompare(brandB);
  //   });
  // };
  
  //******************************* filter product name ****************************/

  // const filterData = (data, searchValue) => {
  //   if (!searchValue.trim()) {
  //     return data;
  //   }
  
  //   const searchLower = searchValue.toLowerCase().trim();
  
  //   return data.filter(group => {
  //     const brand = group.brand?.toLowerCase() || '';
  //     const productName = group.product_name?.toLowerCase() || '';
  //     const fullText = `${brand} ${productName}`;
  
  //     // 1️⃣ Full phrase must match from start of brand OR product name
  //     const phraseMatch =
  //       brand.startsWith(searchLower) ||
  //       productName.startsWith(searchLower);
  
  //     // 2️⃣ Word start match (old behaviour)
  //     const brandWords = brand.split(/\s+/);
  //     const brandMatch = brandWords.some(word =>
  //       word.startsWith(searchLower)
  //     );
  
  //     const productWords = productName.split(/\s+/);
  //     const productMatch = productWords.some(word =>
  //       word.startsWith(searchLower)
  //     );
  
  //     return phraseMatch || brandMatch || productMatch;
  //   }).sort((a, b) => {
  //     const brandA = a.brand?.toLowerCase() || '';
  //     const brandB = b.brand?.toLowerCase() || '';
  //     return brandA.localeCompare(brandB);
  //   });
  // };
  

  //*************************** filter brand plus product name ***************/

  const filterData = (data, searchValue) => {
    if (!searchValue.trim()) {
      return data;
    }
  
    const searchLower = searchValue.toLowerCase().trim();
    const searchWords = searchLower.split(/\s+/);
  
    return data.filter(group => {
      const brand = group.brand?.toLowerCase() || '';
      const productName = group.product_name?.toLowerCase() || '';
      const brandWords = brand.split(/\s+/);
      const productWords = productName.split(/\s+/);
  
      // 🔹 OLD BEHAVIOR (single word search like "ra")
      const phraseMatch =
        brand.startsWith(searchLower) ||
        productName.startsWith(searchLower);
  
      const brandMatch = brandWords.some(word =>
        word.startsWith(searchLower)
      );
  
      const productMatch = productWords.some(word =>
        word.startsWith(searchLower)
      );
  
      const oldBehaviorMatch = phraseMatch || brandMatch || productMatch;
  
      // 🔹 NEW BEHAVIOR (multi-word search like "rasasi hawas")
      let multiWordMatch = false;
  
      if (searchWords.length > 1) {
        multiWordMatch = searchWords.every(word => {
          return (
            brandWords.some(bw => bw.startsWith(word)) ||
            productWords.some(pw => pw.startsWith(word))
          );
        });
      }
  
      return oldBehaviorMatch || multiWordMatch;
    }).sort((a, b) => {
      const brandA = a.brand?.toLowerCase() || '';
      const brandB = b.brand?.toLowerCase() || '';
      return brandA.localeCompare(brandB);
    });
  };

  const filteredProducts = filterData(groupedProducts, searchTerm);

  const clearSearch = () => {
    setSearchTerm("");
  };

  const addToCart = (group, sizeLabel) => {
    const price = group.sizePrices[sizeLabel];
    if (!price || parseFloat(price) <= 0) return;
    
    const variantId = `${group.id}-${sizeLabel}`;
    
    const existingItem = cart.find(item => item.variantId === variantId);
    
    if (existingItem) {
      setCart(prev => prev.map(item => 
        item.variantId === variantId 
          ? {
              ...item,
              quantity: item.quantity + 1,
              totalPrice: calculateItemTotalPrice({
                ...item,
                quantity: item.quantity + 1,
                travelAtomizerQty: item.travelAtomizerQty
              })
            }
          : item
      ));
    } else {
      const cartItemId = Date.now() + Math.random();
      const sizeInMl = parseFloat(sizeLabel);
      
      setCart(prev => [...prev, { 
        id: cartItemId,
        variantId: variantId,
        groupId: group.id,
        brand: group.brand,
        name: group.product_name, 
        size: sizeLabel,
        size_ml: sizeInMl,
        basePrice: parseFloat(price),
        travelAtomizerQty: 0,
        travelAtomizerPrice: 0,
        quantity: 1,
        totalPrice: parseFloat(price),
        is_new: group.is_new
      }]);
    }
  };

  const calculateItemTotalPrice = (item) => {
    const baseTotal = item.basePrice * item.quantity;
    const travelAtomizerPrice = item.travelAtomizerQty * 100 * item.quantity;
    return baseTotal + travelAtomizerPrice;
  };

  const updateQuantity = (cartItemId, newQuantity) => {
    if (newQuantity < 1) {
      removeFromCart(cartItemId);
      return;
    }
    
    setCart(prev => prev.map(item => {
      if (item.id === cartItemId) {
        return {
          ...item,
          quantity: newQuantity,
          totalPrice: calculateItemTotalPrice({
            ...item,
            quantity: newQuantity
          })
        };
      }
      return item;
    }));
  };

  const addTravelAtomizer = (cartItemId) => {
    setCart(prev => prev.map(item => {
      if (item.id === cartItemId && item.size_ml === 10 && item.travelAtomizerQty === 0) {
        const newQty = 1;
        return {
          ...item,
          travelAtomizerQty: newQty,
          totalPrice: calculateItemTotalPrice({
            ...item,
            travelAtomizerQty: newQty
          })
        };
      }
      return item;
    }));
  };
  
  const removeTravelAtomizer = (cartItemId) => {
    setCart(prev => prev.map(item => {
      if (item.id === cartItemId && item.travelAtomizerQty > 0) {
        const newQty = 0;
        return {
          ...item,
          travelAtomizerQty: newQty,
          totalPrice: calculateItemTotalPrice({
            ...item,
            travelAtomizerQty: newQty
          })
        };
      }
      return item;
    }));
  };

  const removeFromCart = (cartItemId) => {
    setCart(prev => prev.filter(item => item.id !== cartItemId));
  };

  const subtotal = cart.reduce((s, item) => s + item.totalPrice, 0);
  const shipping = calculateShipping(subtotal);
  const total = subtotal + shipping;
  const expressUpgradeCost = calculateExpressUpgradeCost(subtotal);

  const handleWhatsAppCheckout = () => {
    if (!cart.length) return;
    if (total < MIN_CHECKOUT_AMOUNT) {
      toast.warning(
        `Minimum order is ₹${MIN_CHECKOUT_AMOUNT}. Add ₹${(MIN_CHECKOUT_AMOUNT - total).toFixed(0)} more to checkout.`
      );
      return;
    }
    let message = "Hello, I would like to order:\n\n";
    cart.forEach((item, index) => {
      message += `${index + 1}. ${item.brand} - ${item.name} (${item.size}) – ₹${item.basePrice}`;
      if (item.quantity > 1) {
        message += ` x${item.quantity}`;
      }
      if (item.travelAtomizerQty > 0) {
        message += `\n   + Travel Atomizer (${item.travelAtomizerQty} per item) – ₹${item.travelAtomizerQty * 100 * item.quantity}`;
      }
      message += `\n   Total: ₹${item.totalPrice}\n`;
    });
    message += "--------------------\n";
    message += `Subtotal: ₹${subtotal.toFixed(2)}\n`;
    message += `Shipping (${selectedShipping === "express" ? "Express" : "Standard"}): ₹${shipping.toFixed(2)}\n`;
    message += `Total Payable: ₹${total.toFixed(2)}\n\n`;
    message += "• Orders are shipped within 4–5 business days via BlueDart, DTDC, Delhivery, or other available courier services based on the delivery address \n\n";
    message += "Please proceed with payment and shipping details.";
  
    const phone = "9881001235";
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  const handleFacebookMessenger = () => {
    
    if (!cart.length) return;
    if (total < MIN_CHECKOUT_AMOUNT) {
      toast.warning(
        `Minimum order is ₹${MIN_CHECKOUT_AMOUNT}. Add ₹${(MIN_CHECKOUT_AMOUNT - total).toFixed(0)} more to checkout.`
      );
      return;
    }
    let message = "Hello, I would like to order:\n\n";
    cart.forEach((item, index) => {
      message += `${index + 1}. ${item.brand} - ${item.name} (${item.size}) – ₹${item.basePrice}`;
      if (item.quantity > 1) {
        message += ` x${item.quantity}`;
      }
      if (item.travelAtomizerQty > 0) {
        message += `\n   + Travel Atomizer (${item.travelAtomizerQty} per item) – ₹${item.travelAtomizerQty * 100 * item.quantity}`;
      }
      message += `\n   Total: ₹${item.totalPrice}\n`;
    });
    message += "--------------------\n";
    message += `Subtotal: ₹${subtotal.toFixed(2)}\n`;
    message += `Shipping (${selectedShipping === "express" ? "Express" : "Standard"}): ₹${shipping.toFixed(2)}\n`;
    message += `Total Payable: ₹${total.toFixed(2)}\n\n`;
    message += "Please proceed with payment and shipping details.";
  
    const pageId = "sameer.munot.7";
 
    const modal = document.createElement('div');
    modal.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.7);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 10000;
    `;
    
    modal.innerHTML = `
      <div style="
        background: white;
        padding: 20px;
        border-radius: 10px;
        max-width: 500px;
        width: 90%;
        max-height: 80vh;
        overflow-y: auto;
      ">
        <h3 style="margin-top: 0; color: #007bff;">Order Details for Facebook Messenger</h3>
        <div style="
          background: #f5f5f5;
          padding: 15px;
          border-radius: 5px;
          margin: 15px 0;
          font-family: monospace;
          white-space: pre-wrap;
          max-height: 300px;
          overflow-y: auto;
        ">
          ${message}
        </div>
        <p style="color: #666; font-size: 14px;">
          <strong>Instructions:</strong><br>
          1. Click "Copy to Clipboard" below<br>
          2. Open Facebook Messenger<br>
          3. Search for our page and paste the message
        </p>
        <div style="display: flex; gap: 10px; margin-top: 20px;">
          <button id="copyToClipboard" style="
            padding: 10px 20px;
            background: #007bff;
            color: white;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            flex: 1;
          ">
            📋 Copy to Clipboard
          </button>
          <button id="openMessenger" style="
            padding: 10px 20px;
            background: #0084ff;
            color: white;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            flex: 1;
          ">
            💬 Open Messenger
          </button>
          <button id="closeModal" style="
            padding: 10px 20px;
            background: #6c757d;
            color: white;
            border: none;
            border-radius: 5px;
            cursor: pointer;
          ">
            ✕ Close
          </button>
        </div>
      </div>
    `;
    
    document.body.appendChild(modal);
    
    modal.querySelector('#copyToClipboard').addEventListener('click', () => {
      navigator.clipboard.writeText(message)
        .then(() => {
          const btn = modal.querySelector('#copyToClipboard');
          btn.textContent = '✅ Copied!';
          btn.style.background = '#28a745';
          setTimeout(() => {
            btn.textContent = '📋 Copy to Clipboard';
            btn.style.background = '#007bff';
          }, 2000);
        })
        .catch(err => {
          console.error('Failed to copy: ', err);
          alert('Failed to copy to clipboard. Please select and copy the text manually.');
        });
    });
    
    modal.querySelector('#openMessenger').addEventListener('click', () => {
      const messengerUrl = `https://m.me/${pageId}`;
      window.open(messengerUrl, '_blank');
    });
    
    modal.querySelector('#closeModal').addEventListener('click', () => {
      document.body.removeChild(modal);
    });
    
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        document.body.removeChild(modal);
      }
    });
  };

  const handleHeaderHover = (sizeLabel) => {
    if (!isMobile) {
      setHoveredSize(sizeLabel);
      const sizeInfo = sizeInfoMap[sizeLabel];
      if (sizeInfo) {
        setSizeImage(sizeInfo.image || "");
        setSizeDescription(sizeInfo.description || "");
      } else {
        setSizeImage("");
        setSizeDescription("");
      }
    }
  };

  const handleHeaderClick = (sizeLabel) => {
    if (isMobile) {
      setHoveredSize(sizeLabel);
      const sizeInfo = sizeInfoMap[sizeLabel];
      if (sizeInfo) {
        setSizeImage(sizeInfo.image || "");
        setSizeDescription(sizeInfo.description || "");
      } else {
        setSizeImage("");
        setSizeDescription("");
      }
    }
  };

  const formatPrice = (price) => {
    if (!price || price === "" || price === null || parseFloat(price) <= 0) return "0";
    return parseFloat(price).toFixed(0);
  };

  const isVariantInCart = (group, sizeLabel) => {
    const variantId = `${group.id}-${sizeLabel}`;
    return cart.some(item => item.variantId === variantId);
  };

  const getPriceForSize = (group, sizeLabel) => {
    return group.sizePrices[sizeLabel];
  };

  const isSizeAvailable = (group, sizeLabel) => {
    const price = getPriceForSize(group, sizeLabel);
    return price && parseFloat(price) > 0;
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading fragrances...</p>
      </div>
    );
  }

  const totalCartQuantity = cart.reduce((total, item) => total + item.quantity, 0);

  return (
    <div className="decants-wrapper">
      <div className="header">
      <div className="header-left">
    <p 
      className="subtitle" 
      onClick={() => navigate('/')}
      style={{ cursor: "pointer" }}
    >
      <span className="back-arrow">←</span>
    </p>
  </div>
        <div className="decants-header">
          <h2 className="title">Decant Price List</h2>
        </div>
        <div className="logo-container">
          {logoLoading ? (
            <div className="logo-placeholder">Loading...</div>
          ) : logoData ? (
            <img 
              src={logoData.image_url} 
              alt="Brand Logo" 
              className="navbar-logo"
              onError={handleLogoError}
              onLoad={() => console.log('Logo loaded successfully:', logoData.image_url)}
            />
          ) : (
            <div className="logo-placeholder">No Logo</div>
          )}
        </div>
      </div>

      <div className="search-container">
        <span className="search-icon">🔍</span>
        <input 
          type="text" 
          className="search" 
          placeholder="Search fragrance (Brand or Name...)"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {searchTerm && (
          <button 
            className="clear-search-btn"
            onClick={clearSearch}
            title="Clear search"
          >
            ✕
          </button>
        )}
      </div>

      <div className="table-wrapper">
        <div className="responsive-table-container">
          <table className="decants-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Fragrance</th>
                {allSizes.map(sizeLabel => (
                  <th 
                    key={sizeLabel} 
                    className="size-header"
                    onMouseEnter={() => !isMobile && handleHeaderHover(sizeLabel)}
                    onMouseLeave={() => !isMobile && setHoveredSize(null)}
                    onClick={() => isMobile && handleHeaderClick(sizeLabel)}
                  >
                    <div className="size-header-content">
                      {sizeLabel}
                      {hoveredSize === sizeLabel && (
                        <div className={`size-image-tooltip ${isMobile ? "mobile-tooltip" : ""}`}>
                          <div className="tooltip-arrow"></div>
                          {sizeImage && (
                            <img 
                              src={sizeImage} 
                              alt={`${sizeLabel} Bottle`}
                              className="size-preview-image"
                              onError={(e) => {
                                console.error('Failed to load size image:', sizeImage);
                                e.target.style.display = 'none';
                              }}
                              onLoad={() => console.log('Size image loaded:', sizeImage)}
                            />
                          )}
                          {sizeDescription && (
                            <div className="size-description">{sizeDescription}</div>
                          )}
                          {!sizeImage && !sizeDescription && (
                            <div className="size-description">No description available</div>
                          )}
                        </div>
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredProducts.length === 0 ? (
                <tr>
                  <td colSpan={allSizes.length + 2} className="no-data">
                    {searchTerm ? "No products found" : "No products available"}
                  </td>
                </tr>
              ) : (
                filteredProducts.map((group, index) => {
                  const productLink = group.link && group.link.trim() !== '' 
                    ? group.link 
                    : group.generatedLink;
                  
                  const hasLink = productLink && productLink.trim() !== '';
                  
                  return (
                    <tr 
                      key={`${group.brand}-${group.product_name}-${index}`} 
                      className={`product-row ${group.is_new ? 'new-product-row' : ''}`}
                    >
                      <td>
                        <div className="row-number">
                          {index + 1}
                        </div>
                      </td>
                      <td className="fragrance-cell">
                        <div className="fragrance-info">
                          <div className="brand-container">
                            <div className="brand">
                              {group.brand} - {group.product_name}
                            </div>
                            <div>
                              {group.is_new && (
                                <span className="new-badge">NEW</span>
                              )}
                            {hasLink && (
                              <a 
                                href={productLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="product-link"
                                title={group.link ? "View Product Details" : "View on Fragrantica"}
                              >
                                <img className="fragrance-icon" src={logo1} alt="Link" />
                              </a>
                            )}
                            </div>
                          </div>
                        </div>
                      </td>
                      
                      {allSizes.map((sizeLabel) => {
                        const price = getPriceForSize(group, sizeLabel);
                        const isAvailable = isSizeAvailable(group, sizeLabel);
                        const isInCart = isAvailable ? isVariantInCart(group, sizeLabel) : false;
                        
                        return (
                          <td 
                            key={sizeLabel} 
                            className="price-cell"
                          >
                            {isAvailable ? (
                              <button
                                className={`price-btn ${isInCart ? "selected" : ""}`}
                                onClick={() => addToCart(group, sizeLabel)}
                                data-tooltip={`Add ${sizeLabel} to cart`}
                              >
                                ₹{formatPrice(price)}
                              </button>
                            ) : (
                              <span className="not-available">N/A</span>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
          {isMobile && hoveredSize && (
            <div
              className="mobile-tooltip-overlay"
              onClick={() => {
                setHoveredSize(null);
                setSizeImage("");
              }}
            />
          )}
        </div>
      </div>

      {cart.length > 0 && (
        <button className="cart-btn floating" onClick={() => setShowCart(true)}>
          <span className="cart-icon">🛒</span>
          <span className="cart-count">{totalCartQuantity}</span>
          <span className="cart-text">View Cart</span>
        </button>
      )}

      {showCart && (
        <div className="cart-overlay" onClick={() => setShowCart(false)}>
          <div className="cart-box" onClick={(e) => e.stopPropagation()}>
            <div className="cart-header">
              <h3>Your Cart</h3>
              <button className="close-btn" onClick={() => setShowCart(false)}>
                ×
              </button>
            </div>

            {cart.length === 0 ? (
              <div className="empty-cart">
                <div className="empty-icon">🛒</div>
                <p>Your cart is empty</p>
                <button className="continue-shopping" onClick={() => setShowCart(false)}>
                  Continue Shopping
                </button>
              </div>
            ) : (
              <>
                <div className="cart-items">
                  {cart.map((item) => (
                    <div className="cart-item" key={item.id}>
                      <div className="cart-item-details">
                        <div className="cart-item-brand">{item.brand}</div>
                        <div className="cart-item-name">
                          {item.name}
                        </div>
                        <div className="cart-item-size">
                          {item.size}
                          
                          <div className="quantity-controls">
                            <button 
                              className="quantity-btn minus"
                              onClick={() => updateQuantity(item.id, item.quantity - 1)}
                            >
                              −
                            </button>
                            <span className="quantity-display">{item.quantity}</span>
                            <button 
                              className="quantity-btn plus"
                              onClick={() => updateQuantity(item.id, item.quantity + 1)}
                            >
                              +
                            </button>
                          </div>
                          
                          <div className="item-price-breakdown">
                            {item.travelAtomizerQty > 0 && (
                              <div className="atomizer-price-breakdown">
                                <span>Travel Atomizer: ₹{item.travelAtomizerQty * 100} × {item.quantity}</span>
                              </div>
                            )}
                          </div>
                        </div>

                        {item.size_ml === 10 && (
                          <div className="travel-atomizer-controls">
                            {item.travelAtomizerQty === 0 ? (
                              <button
                                className="add-atomizer-btn"
                                onClick={() => addTravelAtomizer(item.id)}
                              >
                                Add Travel Atomizer (+₹100 per item)
                              </button>
                            ) : (
                              <button
                                className="remove-atomizer-btn"
                                onClick={() => removeTravelAtomizer(item.id)}
                              >
                                Remove Travel Atomizer (-₹{item.travelAtomizerQty * 100 * item.quantity})
                              </button>
                            )}
                          </div>
                        )}
                      </div>
                      <div className="cart-item-price">
                        <div className="price">₹{item.totalPrice.toFixed(0)}</div>
                        <button 
                          className="remove-btn"
                          onClick={() => removeFromCart(item.id)}
                        >
                          Remove Item
                        </button>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="shipping-options">
                  <h4 className="shipping-title">Shipping Options</h4>
                  
                  <div className="shipping-option-card">
                    <div className="shipping-option-header">
                      <input
                        type="radio"
                        id="standard-shipping"
                        name="shipping"
                        checked={selectedShipping === "standard"}
                        onChange={() => setSelectedShipping("standard")}
                        className="shipping-radio"
                      />
                      <label htmlFor="standard-shipping" className="shipping-label">
                        <div className="shipping-name">Standard Shipping</div>
                        <div className="shipping-price">
                          {subtotal >= STANDARD_FREE_THRESHOLD ? (
                            <span className="free-shipping-badge">FREE</span>
                          ) : (
                            <span>₹{STANDARD_SHIPPING_RATE}</span>
                          )}
                        </div>
                      </label>
                    </div>
                    <div className="shipping-details">
                      <div className="shipping-free-info">
                        {subtotal < STANDARD_FREE_THRESHOLD ? (
                          <span>Free on orders above ₹{STANDARD_FREE_THRESHOLD}</span>
                        ) : (
                          <span className="free-applied">Free Shipping Applied!</span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="shipping-option-card">
                    <div className="shipping-option-header">
                      <input
                        type="radio"
                        id="express-shipping"
                        name="shipping"
                        checked={selectedShipping === "express"}
                        onChange={() => setSelectedShipping("express")}
                        className="shipping-radio"
                      />
                      <label htmlFor="express-shipping" className="shipping-label">
                        <div className="shipping-name">Express Shipping</div>
                        <div className="shipping-price">
                          {subtotal >= EXPRESS_FREE_THRESHOLD ? (
                            <span className="free-shipping-badge">FREE</span>
                          ) : subtotal >= STANDARD_FREE_THRESHOLD ? (
                            <span>₹50</span>
                          ) : (
                            <span>₹{EXPRESS_SHIPPING_RATE}</span>
                          )}
                        </div>
                      </label>
                    </div>
                    <div className="shipping-details">
                      <div className="shipping-free-info">
                        {subtotal < EXPRESS_FREE_THRESHOLD ? (
                          <span>Free on orders above ₹{EXPRESS_FREE_THRESHOLD}</span>
                        ) : (
                          <span className="free-applied">Free Shipping Applied!</span>
                        )}
                      </div>
                    </div>
                  </div>

                  {selectedShipping === "standard" && subtotal >= STANDARD_FREE_THRESHOLD && subtotal < EXPRESS_FREE_THRESHOLD && (
                    <div className="upgrade-info">
                      <span className="upgrade-icon">🔼</span>
                      <span>Upgrade to Express Shipping for only ₹50 more!</span>
                      <button 
                        className="upgrade-btn"
                        onClick={() => setSelectedShipping("express")}
                      >
                        Upgrade Now
                      </button>
                    </div>
                  )}
                </div>

                <div className="shipping-info-card">
                  <div className="shipping-icon">📦</div>
                  <div className="shipping-text">
                    Orders are shipped within 4–5 business days via BlueDart, DTDC, Delhivery, or other available courier services based on the delivery address
                    {selectedShipping === "standard" && subtotal >= STANDARD_FREE_THRESHOLD && (
                      <div className="free-shipping-badge">
                        🎉 Free Shipping Applied (Order above ₹3000)
                      </div>
                    )}
                    {selectedShipping === "express" && subtotal >= EXPRESS_FREE_THRESHOLD && (
                      <div className="free-shipping-badge">
                        🎉 Free Express Shipping Applied (Order above ₹5000)
                      </div>
                    )}
                  </div>
                </div>

                <div className="cart-summary">
                  <div className="summary-row">
                    <span>Subtotal</span>
                    <span>₹{subtotal.toFixed(0)}</span>
                  </div>
                  <div className="summary-row shipping-row">
                    <div className="shipping-label-col">
                      <span>Shipping</span>
                      <div className="shipping-method">
                        {selectedShipping === "express" ? "Express" : "Standard"} Shipping
                      </div>
                    </div>
                    <div className="shipping-value-col">
                      <span className={shipping === 0 ? "free-shipping" : ""}>
                        {shipping === 0 ? "FREE" : `₹${shipping.toFixed(0)}`}
                      </span>
                    </div>
                  </div>
                  
                  {selectedShipping === "standard" && subtotal < STANDARD_FREE_THRESHOLD && (
                    <div className="summary-row shipping-note">
                      <span>Add ₹{(STANDARD_FREE_THRESHOLD - subtotal).toFixed(0)} more for free standard shipping!</span>
                    </div>
                  )}
                  
                  {selectedShipping === "express" && subtotal < EXPRESS_FREE_THRESHOLD && (
                    <div className="summary-row shipping-note">
                      <span>Add ₹{(EXPRESS_FREE_THRESHOLD - subtotal).toFixed(0)} more for free express shipping!</span>
                    </div>
                  )}

                  <div className="summary-row total">
                    <span>Total Amount</span>
                    <span>₹{total.toFixed(0)}</span>
                  </div>
                </div>

                <div className="cart-actions">
                  <button 
                    className="continue-btn"
                    onClick={() => setShowCart(false)}
                  >
                    Continue Shopping
                  </button>
                  <div className="checkout-buttons">
                    <button 
                      className="checkout-btn"
                      onClick={handleWhatsAppCheckout}
                    >
                      <span className="whatsapp-icon">📱</span>
                      Checkout via WhatsApp
                    </button>
                    <button 
                      className="messenger-btn"
                      onClick={handleFacebookMessenger}
                    >
                      <span className="messenger-icon">💬</span>
                      Checkout via Facebook
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}